module.exports = __webpack_public_path__ + "static/media/kristinadapaah-IG-2.45706df7.PNG";